@let toastData = toasts$ | async;
<div [ngClass]="{'p-6': toastData?.length}" class="fixed right-0 top-0 flex flex-col justify-end z-61">
  @for (toast of toastData; track $index) { @if(!!toast.message) {
  <div
    class="toast transition ease-in-out duration-300 transform animate-slide-in fade-in flex border border-gray-200 items-center w-full max-w-xs p-4 mb-2 space-x-4 rtl:space-x-reverse text-gray-500 bg-white rounded-lg shadow"
    role="alert" [ngClass]="{
      'opacity-100 translate-y-0': toast.show,
      'opacity-0 translate-y-4': !toast.show
    }">
    <ng-container *ngTemplateOutlet="toastTemplate; context: { $implicit: toast }"></ng-container>
  </div>
  } }
</div>

<ng-template #toastTemplate let-toast>
  <div class="flex justify-between" [ngClass]="getInfo(toast.type).variant">
    <div class="flex">
      <i class="my-1 icon text-(--scheme-color)" [class]="'icon-' + getInfo(toast.type).icon"></i>

      <div class="ps-2 text-sm font-normal">
        <strong class="font-semibold text-gray-800 text-base">{{
          getInfo(toast.type).label
          }}</strong>
        <p>{{ toast.message }}</p>
      </div>
    </div>

    <button
      class="text-lg size-7 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer font-semibold"
      (click)="close(toast.id)">
      <i class="icon icon-x-close"></i>
    </button>
  </div>
</ng-template>